import React, { useContext } from 'react';
import { Card, Col, Row, TabsProps } from 'antd';

import ComplianceContext from '@totem/components/surveyV2/complianceSummary/complianceContext';
import PolicyCompliance from '@totem/components/surveyV2/complianceSummary/policyCompliance/policyCompliance';
import PortfolioHealthComplianceSummary from '@totem/components/surveyV2/complianceSummary/portfolioHealthOverview/portfolioHealthComplianceSummary';
import FindingsReportContainer from '@totem/components/surveyV2/findingsReport/findingsReportContainer';
import FindingsTable from '@totem/components/surveyV2/findingsReport/FindingsTable';
import LeastCompliantByCategory from '@totem/components/surveyV2/findingsReport/leastCompliantByCategory';
import PolicyResults from '@totem/components/surveyV2/findingsReport/PolicyResults';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import { isNotNull } from '@totem/utilities/common';

import './controlSystemDetail.css';

enum TabType {
  OVERVIEW = 'Overview',
  CONTINUITY = 'System Continuity',
  AUDIT = 'Policy Audit',
  FINDINGS = 'Findings',
}

const ComplianceSelector = () => {
  const { data, input } = useContext(ComplianceContext);

  const renderTabBar = (props: TabsProps, DefaultTabBar: any) => {
    return (
      <div styleName="tabs-container">
        <DefaultTabBar {...props} />
      </div>
    );
  };

  const getTabItems = () => {
    const tabItems: TabsProps['items'] = [
      {
        key: TabType.OVERVIEW,
        label: TabType.OVERVIEW,
        children: (
          <>
            <PortfolioHealthComplianceSummary title={'Health Audit Summary'} />
            <br />
            <PolicyCompliance />
          </>
        ),
      },
    ];

    if (isNotNull(data) && data.auditedControlSystems > 0) {
      tabItems.push({
        key: TabType.AUDIT,
        label: TabType.FINDINGS,
        children: (
          <FindingsReportContainer
            regionIds={input.regionId}
            buildingIds={input.buildingId}
            controlSystemIds={input.controlSystemId}
          >
            <Card title={'Findings Overview'}>
              <Row>
                <Col span={6}>
                  <PolicyResults />
                </Col>
                <Col span={18}>
                  <LeastCompliantByCategory />
                </Col>
              </Row>
            </Card>
            <br />
            <br />
            <Card title={'Findings'}>
              <FindingsTable />
            </Card>
          </FindingsReportContainer>
        ),
      });
    }
    return tabItems;
  };

  return (
    <IBCard title={'Policy Compliance'} isCovered>
      <IBTabs
        defaultActiveKey={TabType.OVERVIEW}
        renderTabBar={renderTabBar}
        items={getTabItems()}
      />
    </IBCard>
  );
};

export default ComplianceSelector;
